module.exports = __webpack_public_path__ + "static/media/Online_Service.5928c1d0.png";